/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import { useSelector } from 'react-redux';

import { CMSHeader } from '@swf/cms';
import { CacheControl } from '@swf/components/ResponseHeaders/ResponseHeaders';
import type { WidgetFC, WidgetInstanceProps } from '@swf/core/types/Widget';

import { headerWidgetModel, useHeaderWidget } from './model';

const HeaderWidget: WidgetFC<WidgetInstanceProps> = () => {
  const { widgetSelect } = useHeaderWidget();
  const { cacheControl, ...data } = useSelector(widgetSelect.get);

  return (
    <>
      {cacheControl && <CacheControl>{cacheControl}</CacheControl>}
      <CMSHeader {...data} />
    </>
  );
};

HeaderWidget.model = headerWidgetModel;

export default HeaderWidget;
